import { Component, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/settings.service';
import { ShopTheming, ThemingService } from 'src/app/theming.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
import { LambdaService } from 'src/app/lambda.service';
declare let $: any;

@Component({
  selector: 'app-edit-gift-card',
  templateUrl: './edit-gift-card.component.html',
  styleUrls: ['./edit-gift-card.component.scss']
})
export class EditGiftCardComponent implements OnInit {
  giftCard: any;
  giftCardTypeId = 0;
  giftCardImage: { imageURL: string; file: File }[] = [];
  showExistingImage = true;
  loading = false;
  quantityArray: number[] = Array.from({ length: 999 }, (_, i) => i + 1);
  monthsArray: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
  amounts: number[] = [0];

  constructor(
    public appComponent: AppComponent,
    private settingsService: SettingsService,
    private themingService: ThemingService,
    public route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private lambdaService: LambdaService,
  ) {
    this.route.paramMap.subscribe(params => {
      const id = Number(params.get('giftCardId'));
      if (id && id !== this.giftCardTypeId) {
        this.appComponent.goToTop();
        this.giftCardTypeId = id;
        this.loadGiftCardData();
      }
    });
  }

  ngOnInit(): void {}

  sanitizeImageURL(imageURL: string) {
    return this.sanitizer.bypassSecurityTrustUrl(imageURL);
  }

  onStatusChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.giftCard.status = target.checked ? 1 : 0;
  }

  triggerFileInput(): void {
    const uploadButton = document.getElementById('btn-upload');
    if (uploadButton && this.giftCardImage.length === 0) {
      uploadButton.removeAttribute('disabled');
      uploadButton.click();
      uploadButton.setAttribute('disabled', 'true');
    }
  }

  onFileSelected(event: any): void {
    const image: File = event.target.files[0];
    if (image && image.type.startsWith('image')) {
      this.uploadImage(image)
        .then((uploadedImage) => {
          this.giftCardImage.push({ 
            imageURL: uploadedImage.imageURL, 
            file: uploadedImage.file
          });
          this.showExistingImage = false;
        })
        .catch((error) => {
          console.error('Error al cargar la imagen:', error);
          alert('Error al cargar la imagen. Por favor intente nuevamente.');
        });
    } else {
      alert('Por favor seleccione una imagen válida');
    }
    event.target.value = '';
  }

  async uploadImage(image: File): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        resolve({
          imageURL: e.target.result,
          file: image
        });
      };
      reader.onerror = () => reject(new Error('Error leyendo archivo'));
      reader.readAsDataURL(image);
    });
  }

  deleteImage(image: any): void {
    if (image === this.giftCard?.images) {
      this.showExistingImage = false;
      this.giftCardImage = [];
    } else {
      this.giftCardImage = this.giftCardImage.filter(img => img !== image);
      if (this.giftCardImage.length === 0) {
        this.showExistingImage = true;
      }
    }
  }

  addAmount(): void {
    this.amounts.push(0);
  }

  removeAmount(index: number): void {
    if (this.amounts.length > 1) {
      this.amounts.splice(index, 1);
    }
  }

  async loadGiftCardData(): Promise<void> {
    this.loading = true;
    try {
      const data: any = await this.lambdaService.getGiftCardTypesById(
        this.themingService.shopId, 
        this.giftCardTypeId
      );
      const resp = JSON.parse(data.body)?.[0];
      
      if (!resp) throw new Error('Tarjeta de regalo no encontrada');
      
      this.giftCard = resp;
      this.amounts = resp.amount?.split(',').map((v: string) => parseFloat(v)) || [0];
      
    } catch (error) {
      console.error('Error cargando datos:', error);
      $('#errorGiftCardsModal').modal('show');
    } finally {
      this.loading = false;
    }
  }

  async validateFormData(): Promise<void> {
    if (!this.giftCard?.name?.trim()) {
      alert('Por favor ingrese un nombre para la tarjeta');
      return;
    }

    const validAmounts = this.amounts.filter(a => a > 0);
    if (validAmounts.length === 0) {
      alert('Debe especificar al menos un monto válido mayor a 0');
      return;
    }

    this.loading = true;
    try {
      let imageUrl = this.giftCard.images || '';
      
      if (this.giftCardImage.length > 0) {
        const image = this.giftCardImage[0];
        const ext = image.imageURL.split(';')[0].split('/')[1] || 'jpg';
        const timestamp = Date.now();
        const key = `${this.themingService.shopId}/${environment.stage}/images/giftcards/giftcard_${timestamp}.${ext}`;
        
        const result: any = await this.lambdaService.uploadFile(
          key, 
          image.file,
          { contentType: `image/${ext}` }
        );
        
        imageUrl = result.imageURL;
      }

      const response: any = await this.lambdaService.updateGiftCard(
        this.giftCardTypeId,
        this.giftCard.name.trim(),
        this.themingService.shopId,
        validAmounts.join(','),
        this.giftCard.stock,
        this.giftCard.status,
        this.giftCard.validMonths,
        imageUrl
      );

      if (response && response.status === 200) {
        $('#successGiftCardsModal').modal('show');
      } else {
        throw new Error('Error en la respuesta del servidor');
      }
      
    } catch (error) {
      console.error('Error actualizando tarjeta:', error);
      $('#errorGiftCardsModal').modal('show');
    } finally {
      this.loading = false;
    }
  }

  closeModal(): void {
    $('#successGiftCardsModal').modal('hide');
    $('#errorGiftCardsModal').modal('hide');
  }
}